module.exports = __webpack_public_path__ + "static/media/basic_plan_icon.239300c0.svg";